import mix from './mix';
export default mix('#000000');